














import { computed, defineComponent, inject, PropType, ref } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import BaseInputFile from "@/components/BaseInputFile";
import OptionItem from "../OptionItem";

export default defineComponent({
  name: "OptionAddCover",
  components: { BaseInputFile, OptionItem },
  props: {
    postData: { type: Object as PropType<ContentSet>, required: true },
  },
  setup(props) {
    const files = ref<FileList | null>(null);
    const postAddFiles = inject<
      (files: FileList, options?: { unshift?: boolean; publicAccess?: boolean }) => Promise<void>
    >("postAddFiles", async () => {});
    const onInput = (files: FileList) => {
      postAddFiles(files, { unshift: true, publicAccess: true });
    };
    const showOption = computed(() => {
      return props.postData.type !== ContentFeedTypeEnum.EVENT;
    });

    const isPhotoGallery = computed(() => {
      return props.postData.type === ContentFeedTypeEnum.PHOTO_GALLERY;
    });

    return {
      showOption,
      files,
      onInput,
      isPhotoGallery,
    };
  },
});
